import { render } from "./AppContent.vue?vue&type=template&id=0ec1a534&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"

import "./AppContent.vue?vue&type=style&index=0&id=0ec1a534&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ec1a534"

export default script